__turbopack_context__.v({
  "animationWrapper": "DeleteAccountModal-module__Xiu5dG__animationWrapper",
  "buttonsWrapper": "DeleteAccountModal-module__Xiu5dG__buttonsWrapper",
  "contentWrapper": "DeleteAccountModal-module__Xiu5dG__contentWrapper",
  "deleteAccountModalWrapper": "DeleteAccountModal-module__Xiu5dG__deleteAccountModalWrapper",
  "endMessageWrapper": "DeleteAccountModal-module__Xiu5dG__endMessageWrapper",
  "fields": "DeleteAccountModal-module__Xiu5dG__fields",
  "formContent": "DeleteAccountModal-module__Xiu5dG__formContent",
  "formWrapper": "DeleteAccountModal-module__Xiu5dG__formWrapper",
  "passwordIcon": "DeleteAccountModal-module__Xiu5dG__passwordIcon",
});
